export let WLAddresses = [

    "0xedf69780EAEfcae1FB20022EeCe19faf8E4071c2",
    "0x8642E80B23009B4a6A6F737fB26bD31BC0cb586d",
    "0x2D71f49369A0EF7Daa60ADe0e18773bc4EDc0B38",
    "0x7F3A129A07e9123f18b2bC35feD01597fE8979e5",
    "0x8898f87D0BeD3f7e4e1211ccA8D1b20d981c4055",
    "0x119ecf61d6741A92De391f70Aa5aE205b999d804",
    "0xbd9ec73a13505BfC253203141eb072E716ABb6bE",
    "0x621589DA71dd7Bcfa76641f755c0a2Ce28e3A946",
    "0x46BaC855CeDA31Ad63874899338C087218Fb765E",
    "0x1c2d965004074e9Fc7A0c8686E47Ae56D035909e",
    "0xADbe480f80FF6a57Ed749102eA80d51A063E0fDb",
    "0x2Dd1E854d94539E32Ac6800E7924011cE04B24B2",
    "0x60c2955E84766e933a6dA46C483BfCfb6C25Cdff",
    "0xbd11d09ca71e1aca0a5eddf37fafb36f1e4f72bf",
    "0x45A34C1374163281AbD1266968e683503cC7841D",
    "0x5ddF2704AC96cD8e9Ea7355f3343B7ADA1Ad86F5",
    "0x7a98c2df933ae4d64df473731e69c81cd2283032",
    "0x81A25Ce2c22DCa65B6033fda75B675005C985651",
    "0xCf80084B636E830bf21A97757f63DDA9d7AbA09c",
    "0x0007452340DC415Eed97f36a6516DD7eBE6a1f0c",
    "0x84e5324aB39dFa82337fbbE4A8bC652a87fBA2fA",
    "0x157b0cA00F3dFC9377D08008a52E30D9796FA169",
    "0x822F187b138A69516181780F0106043628C560c2",
    "0x92C6D875Afe79882Ce78cdaa21936069a97AF26D",
    "0x98f6d085E38407174EF3300f53834ec1Ad542196",
    "0x499b1755602448937edba8f91d057e3066a158f6",
    "0xf154bd5547339ff46ac57289addfbdc5760035aa",
    "0x5836165BBb8A64E6698030378271e47B6Bb97383",
    "0xab354d41ba6c345b1a22faf373506bdc96d57336",
    "0x8a12bBB15e3fED4201311583818FFDC0cCB0E394",
    "0x754f7D9337C334011423C85e50727634fb7AC076",
    "0x2137025A83b70bC32e61835879d702d8E8A464f5",
    "0x36f33160E5F03eFf0Cc8d1f54D7Ac640a705eFE1",
    "0x7524ABF5fE718F2EC5c47f4761A392Bf026B9421",
    "0x46BaC855CeDA31Ad63874899338C087218Fb765E",
    "0x556aFd916c38efAdd6a607f220154dc4C368ad6a",
    "0x98575c03c88c8f7c424af302a364d9a55c0299b3",
    "0x2B1eA94A802eD65A9CcBCebc3D3943799159fE30",

]